import { Injectable } from '@angular/core';
import { IdCampiCtxMenu } from '../../common/configuration/id-campi-ctx-menu';
import { NomiDescrittoriSezione } from '../../common/configuration/nomi-descrittori-sezione';
import { CampoCtxMenu } from '../../common/models/campo-ctx-menu';
import { ConfigurationUtilServiceDto } from '../../common/models/configuration-util-service-dto';
import { CtxBodyFascicoloIns } from '../../common/models/ctx-body-fascicolo-ins';
import { CtxMenuSezioni } from '../../common/models/ctx-menu-sezioni';
import { DescrittoreSezione } from '../../common/models/descrittore-sezione';
import { FascicoloMap } from '../../common/models/fascicolo-map';
import { FascicoloFull } from '../../common/models/fascicolo/fascicolo-full';
import { PraticaMap } from '../../common/models/pratica-map';
import { PrivateUtilServiceObject } from '../../common/models/private-util-service-object';
import { StatoInserimento } from '../../common/models/stato-inserimento';
import { CacheDescrittori } from '../models/cache-descrittori';
import { OperationsService } from './operations.service';
import { RoutingConfigurationUtilService } from './routing-configuration-util.service';
import { BehaviorSubject, Observable, of, tap } from 'rxjs';

declare var getFascicoloMapSync;
declare var getPraticaMapSync;

@Injectable()
export class ConfigurationUtilService {
  private idTipofascicoloMapCached: any;
  private idTipopraticaMapCached: any;
  private fascicoloMapCached: FascicoloMap;
  private praticaMapCached: PraticaMap;
  private _descrittoriMap: BehaviorSubject<any> = new BehaviorSubject(null);
  public descrittoriMap: Observable<any> = this._descrittoriMap.asObservable();
  constructor(
    private operations: OperationsService,
    private routingService: RoutingConfigurationUtilService
  ) {}

  public configuraCtxMenuVisualizzazionePratica(
    cusd: ConfigurationUtilServiceDto
  ): ConfigurationUtilServiceDto {
    // debugger;
    if (
      cusd.msg.idTipoPratica !== this.idTipopraticaMapCached ||
      !this.praticaMapCached
    ) {
      this.setPraticaFromMap(cusd.msg.idTipoPratica);
    }
    cusd.ctxMenu.upperList = this.praticaMapCached.upperListView;
    let descrittoriUL = this.configuraCtxMenuByList(
      cusd.ctxMenu.upperList,
      cusd.msg.idEntita,
      cusd.msg.idActiveButton,
      cusd.descrittoriMap,
      cusd.descrittoriCached
    );
    if (descrittoriUL && descrittoriUL.length > 0) {
      cusd.descrittoriBody = descrittoriUL;
    }

    cusd.ctxMenu.lowerList = this.praticaMapCached.lowerListView;
    let descrittoriLL = this.configuraCtxMenuByList(
      cusd.ctxMenu.lowerList,
      cusd.msg.idEntita,
      cusd.msg.idActiveButton,
      cusd.descrittoriMap,
      cusd.descrittoriCached
    );
    if (descrittoriLL && descrittoriLL.length > 0) {
      cusd.descrittoriBody = descrittoriLL;
    }

    cusd.url = this.praticaMapCached.pathView;

    return cusd;
  }

  public configuraCtxMenuVisualizzazioneFascicolo(
    cusd: ConfigurationUtilServiceDto
  ): ConfigurationUtilServiceDto {
    // if (
    //   cusd.msg.idTipoFascicolo !== this.idTipofascicoloMapCached ||
    //   cusd.msg.idTipoPratica !== this.idTipopraticaMapCached
    // ) {
      this.setFascicoloFromMap(
        cusd.msg.idTipoFascicolo,
        cusd.msg.idTipoPratica,
        null,
        null
      );
    // }
    cusd.ctxMenu.upperList = this.fascicoloMapCached.upperListView;
    let descrittoriUL = this.configuraCtxMenuByList(
      cusd.ctxMenu.upperList,
      cusd.msg.idEntita,
      cusd.msg.idActiveButton,
      cusd.descrittoriMap,
      cusd.descrittoriCached
    );
    if (descrittoriUL && descrittoriUL.length > 0) {
      cusd.descrittoriBody = descrittoriUL;
    }

    cusd.ctxMenu.lowerList = this.fascicoloMapCached.lowerListView;
    let descrittoriLL = this.configuraCtxMenuByList(
      cusd.ctxMenu.lowerList,
      cusd.msg.idEntita,
      cusd.msg.idActiveButton,
      cusd.descrittoriMap,
      cusd.descrittoriCached
    );
    if (descrittoriLL && descrittoriLL.length > 0) {
      cusd.descrittoriBody = descrittoriLL;
    }
    cusd.url = this.fascicoloMapCached.pathView;

    return cusd;
  }

  public configuraCtxMenuCreazionePratica(
    cusd: ConfigurationUtilServiceDto
  ): ConfigurationUtilServiceDto {
    if (
      cusd.msg.idTipoPratica !== this.idTipopraticaMapCached ||
      !this.praticaMapCached
    ) {
      this.setPraticaFromMap(cusd.msg.idTipoPratica);
    }
    cusd.ctxMenu.upperList = this.praticaMapCached.upperListCreate;
    let descrittoriUL = this.configuraCtxMenuByList(
      cusd.ctxMenu.upperList,
      cusd.msg.idEntita,
      cusd.msg.idActiveButton,
      cusd.descrittoriMap,
      cusd.descrittoriCached
    );
    if (descrittoriUL && descrittoriUL.length > 0) {
      cusd.descrittoriBody = descrittoriUL;
    }

    cusd.ctxMenu.lowerList = this.praticaMapCached.lowerListCreate;
    let descrittoriLL = this.configuraCtxMenuByList(
      cusd.ctxMenu.lowerList,
      cusd.msg.idEntita,
      cusd.msg.idActiveButton,
      cusd.descrittoriMap,
      cusd.descrittoriCached
    );
    if (descrittoriLL && descrittoriLL.length > 0) {
      cusd.descrittoriBody = descrittoriLL;
    }
    cusd.url = this.praticaMapCached.pathCreate;
    return cusd;
  }

  public configuraCtxMenuCreazioneFascicolo(
    cusd: ConfigurationUtilServiceDto, idPratica: string
  ): ConfigurationUtilServiceDto {
    // if (
    //   cusd.msg.idTipoFascicolo !== this.idTipofascicoloMapCached ||
    //   cusd.msg.idTipoPratica !== this.idTipopraticaMapCached
    // ) {
      this.setFascicoloFromMap(
        cusd.msg.idTipoFascicolo,
        cusd.msg.idTipoPratica,
        null,
        idPratica
      );
    // }
    cusd.ctxMenu.upperList = this.fascicoloMapCached.upperListCreate;
    let descrittoriUL = this.configuraCtxMenuByList(
      cusd.ctxMenu.upperList,
      cusd.msg.idEntita,
      cusd.msg.idActiveButton,
      cusd.descrittoriMap,
      cusd.descrittoriCached
    );
    if (descrittoriUL && descrittoriUL.length > 0) {
      cusd.descrittoriBody = descrittoriUL;
    }

    cusd.ctxMenu.lowerList = this.fascicoloMapCached.lowerListCreate;
    let descrittoriLL = this.configuraCtxMenuByList(
      cusd.ctxMenu.lowerList,
      cusd.msg.idEntita,
      cusd.msg.idActiveButton,
      cusd.descrittoriMap,
      cusd.descrittoriCached
    );
    if (descrittoriLL && descrittoriLL.length > 0) {
      cusd.descrittoriBody = descrittoriLL;
    }
    cusd.url = this.fascicoloMapCached.pathCreate;

    return cusd;
  }

  public configuraCtxMenuInserimentoFascicolo(
    cusd: ConfigurationUtilServiceDto, idFascicolo: string
  ): ConfigurationUtilServiceDto {
    // if (
    //   cusd.msg.idTipoFascicolo !== this.idTipofascicoloMapCached ||
    //   cusd.msg.idTipoPratica !== this.idTipopraticaMapCached
    // ) {
      this.setFascicoloFromMap(
        cusd.msg.idTipoFascicolo,
        cusd.msg.idTipoPratica,
        idFascicolo,
        null
      );
    // }
    cusd.url = this.fascicoloMapCached.pathIns;
    this._descrittoriMap.next(cusd.descrittoriMap);
    this.getFascicoloWhileInserting(cusd);
    return cusd;
  }

  private getFascicoloWhileInserting(cusd: ConfigurationUtilServiceDto) {
    this.operations
      .readFascicolo(cusd.url, cusd.msg.idEntita)
      .subscribe((readFascicoloResponse) =>
        this.switchCtxMenuInserimento(cusd, readFascicoloResponse.fascicolo)
      );
  }

  private switchCtxMenuInserimento(
    cusd: ConfigurationUtilServiceDto,
    fascicoloFull: FascicoloFull,
  ) {
    cusd.fascicolo = fascicoloFull;
    let priv: PrivateUtilServiceObject = null;
    cusd.mandatoryNotCompiled = 0;
    // if (
    //   cusd.msg.idTipoFascicolo !== this.idTipofascicoloMapCached ||
    //   cusd.msg.idTipoPratica !== this.idTipopraticaMapCached
    // ) {
      this.setFascicoloFromMap(
        cusd.msg.idTipoFascicolo,
        cusd.msg.idTipoPratica,
        null,
        fascicoloFull.praticaBase.id
      );
    // }
    cusd.ctxMenu.upperList = this.fascicoloMapCached.upperListIns;
    priv = this.configuraCtxMenuInserimentoFascicoloByList(
      cusd.ctxMenu.upperList,
      cusd.msg.idEntita,
      cusd.msg.idActiveButton,
      cusd.descrittoriMap,
      cusd.descrittoriCached,
      cusd.fascicolo
    );
    cusd.mandatoryNotCompiled += priv.mandatoryNotCompiled;
    if (priv.descrittori && priv.descrittori.length > 0) {
      cusd.descrittoriBody = priv.descrittori;
    }

    cusd.ctxMenu.lowerList = this.fascicoloMapCached.lowerListIns;
    priv = this.configuraCtxMenuInserimentoFascicoloByList(
      cusd.ctxMenu.lowerList,
      cusd.msg.idEntita,
      cusd.msg.idActiveButton,
      cusd.descrittoriMap,
      cusd.descrittoriCached,
      cusd.fascicolo
    );
    cusd.mandatoryNotCompiled += priv.mandatoryNotCompiled;
    if (priv.descrittori && priv.descrittori.length > 0) {
      cusd.descrittoriBody = priv.descrittori;
    }

    cusd.statoInserimento = this.configuraStatoCtxMenu(priv, cusd.ctxMenu);
    cusd._ctxMenuSezioni.next(cusd.ctxMenu);
    cusd._ctxBody.next(
      new CtxBodyFascicoloIns(
        cusd.descrittoriBody,
        cusd.fascicolo,
        cusd.statoInserimento
      )
    );
  }

  private configuraCtxMenuByList(
    campi: CampoCtxMenu[],
    idPratica: string,
    idActive: string,
    descrittori: { [id: string]: DescrittoreSezione },
    descrittoriCached: CacheDescrittori
  ): DescrittoreSezione[] {
    let descrittoriBody: DescrittoreSezione[] = [];
    for (let campo of campi) {
      campo.idPratica = idPratica;
      // campo.setIdEntita(idPratica);

      if (campo.id === idActive) {
        campo.active = true;
        let esmSezioneAttiva: string[] = campo.descrittori;
        for (let esm of esmSezioneAttiva) {
          let descrittoreBody: DescrittoreSezione =
            descrittoriCached.descrittoriMap[esm];
          if (descrittoreBody) {
            descrittoriBody.push(descrittoreBody);
          }
        }
      } else {
        campo.active = false;
      }

      for (let esm of campo.descrittori) {
        if(!descrittori[esm]) continue
        if (campo.id === "documentazione_allegata_fascicolo") {
          campo.disabled =
            !descrittori["SezioneDocumentazioneAllegata"].readable &&
            !descrittori["SezioneDocumentazioneAllegata"].writable;
        } else {
          campo.disabled =
            !descrittori[esm].readable && !descrittori[esm].writable;
        }
      }

    }
    return descrittoriBody;
  }

  private configuraCtxMenuInserimentoFascicoloByList(
    campi: CampoCtxMenu[],
    idEntita: string,
    idActive: string,
    descrittori: { [id: string]: DescrittoreSezione },
    descrittoriCached: CacheDescrittori,
    fascicoloFull: FascicoloFull
  ): PrivateUtilServiceObject {
    let descrittoriBody: DescrittoreSezione[] = [];
    let mandatoryNotCompiled = 0;
    let assegnazioneSmistamento: boolean = false;
    let assegnazioneCompetenza: boolean = false;
    let legali: boolean = false;
    for (let i = 0; i < campi.length; i++) {
      let campo: CampoCtxMenu = campi[i];
      campo.idPratica = idEntita;
      // campo.setIdEntita(idEntita);

      if (campo.id !== idActive) {
        // se il campo non � quello attivo attualmente
        campo.active = false; // lo setto a non-attivo
        mandatoryNotCompiled += this.searchForMandatoryNotCompiled(
          campo,
          fascicoloFull
        ); // verifico che il campo sia compilato e, se non lo �, ed � mandatorio, incremento il contatore dei mandatori non compilati

        // gestisco la disabilitazione dei campi non attualmente attivi, in base ai relativi descrittori
        /*let disabled = true; // come stato iniziale, disabilito il campo
        for (let esm of campo.descrittori) {
          // se nei descrittori per quel campo trovo almeno un read, lo ri-abilito
          if (
            descrittori[esm] &&
            (descrittori[esm].readable || descrittori[esm].writable)
          ) {
            disabled = false;
          }
        }
        campo.disabled = disabled;*/
        for (let esm of campo.descrittori) {
          if (descrittori[esm] && !descrittori[esm].readable) {
            campo.disabled = true;
          }
        }
      } else {
        // se invece il campo � quello attivo
        campo.active = true; // lo setto ad attivo
        mandatoryNotCompiled += this.searchForMandatoryNotCompiled(
          campo,
          fascicoloFull
        ); // verifico che il campo sia compilato e, se non lo �, ed � mandatorio, incremento il contatore dei mandatori non compilati

        let entSimpleNamesSezioneAttiva: string[] = campo.descrittori; // calcolo i descrittori per il body
        for (let esn of entSimpleNamesSezioneAttiva) {
          let descrittoreBody: DescrittoreSezione =
            descrittoriCached.descrittoriMap[esn];
          if (descrittoreBody) {
            descrittoriBody.push(descrittoreBody);
          }
        }
      }
      if (
        campo.id === IdCampiCtxMenu.ASSEGNAZIONE_PER_SMISTAMENTO_INS ||
        campo.id === IdCampiCtxMenu.ASSEGNAZIONE_PER_COMPETENZA_INS ||
        campo.id === IdCampiCtxMenu.LEGALI_FASCICOLO_INS
      ) {
        if (campo.id !== idActive) {
          campo.active = false;
          assegnazioneSmistamento = this.checkStatoFascicolo(
            campo,
            fascicoloFull
          );
          assegnazioneCompetenza = this.checkStatoFascicolo(
            campo,
            fascicoloFull
          );
          legali = this.checkStatoFascicolo(campo, fascicoloFull);
          /*let disabled = true;
          for (let esm of campo.descrittori) {
            if (
              descrittori[esm] &&
              (descrittori[esm].readable || descrittori[esm].writable)
            ) {
              disabled = false;
            }
            if (
              descrittori[esm] &&
              descrittori[esm].entitySimpleName ===
                NomiDescrittoriSezione.SEZIONE_LEGALI_FASCICOLO &&
              !legali
            ) {
              disabled = true;
            }
          }
          campo.disabled = disabled;*/
          for (let esm of campo.descrittori) {
            if (descrittori[esm] && !descrittori[esm].readable) {
              campo.disabled = true;
            }
            if (descrittori[esm] && (descrittori[esm].entitySimpleName === NomiDescrittoriSezione.SEZIONE_LEGALI_FASCICOLO && !legali)) {
              campo.disabled = true;                }
          }
        } else {
          campo.active = true;
          assegnazioneSmistamento = this.checkStatoFascicolo(
            campo,
            fascicoloFull
          );
          assegnazioneCompetenza = this.checkStatoFascicolo(
            campo,
            fascicoloFull
          );

          legali = this.checkStatoFascicolo(campo, fascicoloFull);

          if (campo.id !== IdCampiCtxMenu.LEGALI_FASCICOLO_INS) {
            let entSimpleNamesSezioneAttiva: string[] = campo.descrittori; // calcolo i descrittori per il body
            for (let esn of entSimpleNamesSezioneAttiva) {
              let descrittoreBody: DescrittoreSezione =
                descrittoriCached.descrittoriMap[esn];
              if (descrittoreBody) {
                descrittoriBody.push(descrittoreBody);
              }
            }
          }
        }
      }
    }
    let priv: PrivateUtilServiceObject = new PrivateUtilServiceObject();
    priv.descrittori = descrittoriBody;
    priv.mandatoryNotCompiled = mandatoryNotCompiled;
    priv.assegnazioneSmistamento = assegnazioneSmistamento;
    priv.assegnazioneCompetenza = assegnazioneCompetenza;
    priv.legali = legali;
    return priv;
  }

  private configuraStatoCtxMenu(
    priv: PrivateUtilServiceObject,
    ctxMenu: CtxMenuSezioni
  ): StatoInserimento {
    let statoInserimento: StatoInserimento = new StatoInserimento();
    statoInserimento.mandatoryNotCompiled = priv.mandatoryNotCompiled;
    statoInserimento.assegnazionePerSmistamento = false;
    statoInserimento.assegnazionePerCompetenza = false;
    statoInserimento.legali = false;
    return statoInserimento;
  }

  private searchForMandatoryNotCompiled(
    campo: CampoCtxMenu,
    fascicoloFull: FascicoloFull
  ): number {
    let mandatoryNotCompiled = 0;
    switch (
      campo.id // verifico che il campo sia compilato e, se non lo �, ed � mandatorio, incremento il contatore dei mandatori non compilati
    ) {
      case IdCampiCtxMenu.CONTROPARTI_FASCICOLO_INS:
        if (fascicoloFull.idSezioneControparti) {
          campo.grey = false;
        } else if (campo.mandatory === true) {
          mandatoryNotCompiled += 1;
        }
        break;
      case IdCampiCtxMenu.ALTRE_PARTI_FASCICOLO_INS:
        if (fascicoloFull.idSezioneAltreParti) {
          campo.grey = false;
        } else if (campo.mandatory === true) {
          mandatoryNotCompiled += 1;
        }
        break;
      case IdCampiCtxMenu.SEZIONE_ECONOMICA_FASCICOLO_INS:
        if (fascicoloFull.idSezioneDatiEconomici) {
          campo.grey = false;
        } else if (campo.mandatory === true) {
          mandatoryNotCompiled += 1;
        }
        break;
      case IdCampiCtxMenu.ATTI_FASCICOLO_INS:
        if (fascicoloFull.idSezioneAtti) {
          campo.grey = false;
        } else if (campo.mandatory === true) {
          mandatoryNotCompiled += 1;
        }
        break;
      case IdCampiCtxMenu.SCADENZARIO_FASCICOLO_INS:
        if (fascicoloFull.idSezioneScadenze) {
          campo.grey = false;
        } else if (campo.mandatory === true) {
          mandatoryNotCompiled += 1;
        }
        break;
        case IdCampiCtxMenu.DOCUMENTAZIONE_ALLEGATA_FASCICOLO_INS:
          if (fascicoloFull.idSezioneDocumentazioneAllegata) {
              this.operations.getDocumentazione(fascicoloFull.praticaBase.tipoPratica.endpoint, fascicoloFull.id).subscribe( res => {
                if(res){
                  const check = Object.entries(res).find(([key, value]) => key.includes('documenti') && (Array.isArray(value) && value.length > 0));
                  if(check){
                    campo.grey = false;
                  }
                }
              })
          }
           if (campo.grey === true && campo.mandatory === true) {
            mandatoryNotCompiled += 1;
          }
          break;
      }
      return mandatoryNotCompiled;
    }


  private checkStatoFascicolo(
    campo: CampoCtxMenu,
    fascicoloFull: FascicoloFull
  ): boolean {
    let assegnazione = true;
    switch (campo.id) {
      case IdCampiCtxMenu.ASSEGNAZIONE_PER_SMISTAMENTO_INS:
        if (
          this.routingService.isFascicoloInSmistamento(fascicoloFull) ||
          this.routingService.isFascicoloInAssegnazione(fascicoloFull) ||
          this.routingService.isFascicoloInAssegnazioneLegale(fascicoloFull)
        ) {
          campo.grey = false;
        } else if (campo.mandatory === true) {
          assegnazione = false;
        }
        break;
      case IdCampiCtxMenu.ASSEGNAZIONE_PER_COMPETENZA_INS:
        if (
          this.routingService.isFascicoloInAssegnazione(fascicoloFull) ||
          this.routingService.isFascicoloInAssegnazioneLegale(fascicoloFull)
        ) {
          campo.grey = false;
        } else if (campo.mandatory === true) {
          assegnazione = false;
        }
        break;
      case IdCampiCtxMenu.LEGALI_FASCICOLO_INS:
        if (
          this.routingService.isFascicoloInAssegnazioneLegale(fascicoloFull)
        ) {
          campo.grey = false;
        } else if (campo.mandatory === true) {
          assegnazione = false;
        }
        break;
    }
    return assegnazione;
  }

  private setFascicoloFromMap(idTipoFascicoloMap: any, idTipoPraticaMap: any, idFascicolo?: string, idPratica?: string) {
    // let nomeFascicoloFE = FrontEndMapping.tipiFascicolo[idTipoFascicoloMap];
    // let nomePraticaFE = FrontEndMapping.tipiPratica[idTipoPraticaMap];
    this.idTipofascicoloMapCached = idTipoFascicoloMap;
    this.idTipopraticaMapCached = idTipoPraticaMap;
    let fascicolo: Observable<FascicoloMap> = of(getFascicoloMapSync(idTipoPraticaMap, idTipoFascicoloMap));
    fascicolo.subscribe(
      fascicolo => {
        if (idPratica) {
          this.operations.checkVisibilityPratica(idPratica).pipe(
            tap(res => {
              if (!res) {
                fascicolo.upperListCreate.find(el => el.id === IdCampiCtxMenu.DATI_GENERALI_PRATICA_CREATE).disabled = true;
                fascicolo.upperListIns.find(el => el.id === IdCampiCtxMenu.DATI_GENERALI_PRATICA)
                  .disabled = true;
              }
              this.fascicoloMapCached = fascicolo;
            })
          ).subscribe();
        }

        if (idFascicolo) {
          this.operations.checkVisibilityFascicolo(null, idFascicolo).pipe(
            tap(res => {
              if (!res) {
                fascicolo.upperListCreate.find(el => el.id === IdCampiCtxMenu.DATI_GENERALI_PRATICA_CREATE).disabled = true;
                fascicolo.upperListIns.find(el => el.id === IdCampiCtxMenu.DATI_GENERALI_PRATICA)
                  .disabled = true;
              }
              this.fascicoloMapCached = fascicolo;
            })
          ).subscribe();
        }
        this.fascicoloMapCached = fascicolo;
      }
    )

  }


  private setPraticaFromMap(idTipoPraticaMap: any) {
    // let nomePraticaFE = FrontEndMapping.tipiPratica[idTipoPraticaMap];
    let pratica = getPraticaMapSync(idTipoPraticaMap);
    this.idTipopraticaMapCached = idTipoPraticaMap;
    this.idTipofascicoloMapCached = null;
    this.praticaMapCached = pratica;
  }
}
